/* src/components/pdf-pagebreak/pdf-pagebreak.component.scss */
app-pdf-pagebreak {
  display: block;
  page-break-before: always;
}
/*# sourceMappingURL=pdf-pagebreak.component-J45FXA3O.css.map */
